module.exports = __webpack_public_path__ + "static/media/samsung.68831432.png";